<app-modal-base [title]="title" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <form [formGroup]="form">
      <div class="form-group row">
        @if (type === PropertyBookletEquipmentType.heatingMaintenance) {
          <div class="col-12">
            <app-input type="date" label="Date de maintenance" [formControl]="form_maintenanceDate"></app-input>
          </div>
        }

        @if (type !== PropertyBookletEquipmentType.heatingMaintenance && isBookletRenovation) {
          @if (type === PropertyBookletEquipmentType.network) {
            <div class="col-12">
              <app-input type="date" label="Date des travaux" [formControl]="form_installationDate"></app-input>
            </div>
          } @else {
            <app-input type="date" label="Date des travaux" [formControl]="form_installationDate"></app-input>
          }
        }

        @if (type !== PropertyBookletEquipmentType.heatingMaintenance && type !== PropertyBookletEquipmentType.network) {
          <app-select label="Classification" [formControl]="form_energyClassification" [list]="energyClassificationList"
          [isEnum]="true" [enumName]="'EnergyClassification'" [isMultiple]="false"></app-select>
        }
      </div>
      <div class="form-group row">
        @if (arePopulateData) {
          @if (type !== PropertyBookletEquipmentType.heatingMaintenance && type !== PropertyBookletEquipmentType.network) {
            <div class="col-12 col-md-6">
              <app-doc-add-widget [prop]="data.prop" category="ENERGY" title="Fiche Produit *"
                (docSelected)="onProductSheetDocSelected($event)" (docDeleted)="onProductSheetDocDeleted()"
                [withSelect]="true" [withType]="false" [document]="form_productSheet.value">
              </app-doc-add-widget>
              <mat-error>
                <span *ngIf="form.touched && form_productSheet.hasError('required')">La fiche produit est
                  obligatoire</span>
              </mat-error>
            </div>
            <div class="col-12 col-md-6">
              <app-doc-add-widget [prop]="data.prop" category="ENERGY" title="Détail installation"
                (docSelected)="onInstallationDetailsDocSelected($event)" (docDeleted)="onInstallationDetailsDocDeleted()"
                [withSelect]="true" [withType]="false" [document]="form_installationDetails.value">
              </app-doc-add-widget>
              <mat-error>
                <span *ngIf="form.touched && form_installationDetails.hasError('required')">Le détail de l'installation est
                  obligatoire</span>
              </mat-error>
            </div>
            <div class="col-12 col-md-6">
              <app-doc-add-widget [prop]="data.prop" category="ENERGY" title="Notice"
                (docSelected)="onOperationManualDocSelected($event)" (docDeleted)="onOperationManualDocDeleted()"
                [withSelect]="true" [withType]="false" [document]="form_operationManual.value">
              </app-doc-add-widget>
              <mat-error>
                <span *ngIf="form.touched && form_operationManual.hasError('required')">La notice est
                  obligatoire</span>
              </mat-error>
            </div>
          } @else if (type === PropertyBookletEquipmentType.heatingMaintenance) {
            <div class="col-12">

              <app-select label="Type" [formControl]="form_maintenanceType" [list]="maintenanceTypeList"
                [isEnum]="true" [enumName]="'MaintenanceTypeList'" [isMultiple]="false"></app-select>


              <app-doc-add-widget [prop]="data.prop" category="ENERGY" title="Certificat de maintenance *"
                (docSelected)="onMaintenanceCertificateDocSelected($event)" (docDeleted)="onMaintenanceCertificateDocDeleted()"
                [withSelect]="true" [withType]="false" [document]="form_maintenanceCertificate.value">
              </app-doc-add-widget>
              <mat-error>
                <span *ngIf="form.touched && form_maintenanceCertificate.hasError('required')">Le document est obligatoire</span>
              </mat-error>
            </div>
          } @else if (type === PropertyBookletEquipmentType.network) {
            <div class="col-12">
              <app-input label="Nom réseau" [formControl]="form_subStation"></app-input>

              <app-doc-add-widget [prop]="data.prop" category="ENERGY" title="Détail installation"
                (docSelected)="onInstallationDetailsDocSelected($event)" (docDeleted)="onInstallationDetailsDocDeleted()"
                [withSelect]="true" [withType]="false" [document]="form_installationDetails.value">
              </app-doc-add-widget>
              <mat-error>
                <span *ngIf="form.touched && form_installationDetails.hasError('required')">Le détail de l'installation est
                  obligatoire</span>
              </mat-error>
            </div>
          }
        }
      </div>
    </form>
  </div>
</ng-template>
